import React, { useEffect, useState } from "react";
import { CircularProgress, Grid } from "@mui/material";
import SortContext from "context/SortContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import GoToTop from "components/ui/GoToTop";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import { useGlobalContext } from "context/GlobalContext";
import StockSetProduct from "./StockSetProduct";
import { useStockSetDesings } from "../api/getStockSetProduct";

const StockSetsProducts = () => {
  const { setid } = useParams();
  const { selectedSortValue, sortOptions, search } = React.useContext(SortContext);
  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;
  const [stockProductData, setStockProductData] = useState([]);
  const { setFilterChangeCount, setDisplayCount, setFilterChangeDesignCount, dynamicfilterCount, filterChangeCount, setSearchResultCount, setDynamicFilterCount } = useGlobalContext();
  let isNormalFilter = JSON.parse(sessionStorage.getItem("appliedFilterValues") || "{}");
  let Location = (isNormalFilter?.Location?.length > 0 ? isNormalFilter.Location : ["Headquarters Stock", "BBM Stock", "BBM Customer Stock", "BBS Stock", "BBS Customer Stock", "IDL"]).map(
    (location) => (location === "IDL" ? "Idel Inventory" : location)
  );
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, error } = useStockSetDesings({
    setId: setid,
    limit: 30,
    sortBy: selectedSortBY,
    sortOrder: selectedSortOrder,
    searchTerm: search,
    location: Location,
  });

  useEffect(() => {
    const combinedData = data?.pages?.flatMap((page) => page?.stockSetDesigns);
    setStockProductData(combinedData);
    if (search === "") {
      setDynamicFilterCount(true);
    }
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.pages[0]?.totalSerachAndFilter);
      // setFilterChangeDesignCount(data?.pages[0]?.totalStyles);
      setSearchResultCount(data?.pages[0]?.totalSerachAndFilter);
    } else {
      setSearchResultCount(data?.pages[0]?.totalSerachAndFilter);
      setFilterChangeCount(filterChangeCount);
      // setFilterChangeDesignCount(filterChangeDesignCount);
    }
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  if (isLoading) return <ProductSkeleton count={10} />;
  if (isError) return <div>Error: {error?.message}</div>;

  return (
    <>
      <InfiniteScroll
        dataLength={data?.pages.flatMap((page) => page.stockSetDesigns).length || 0}
        next={fetchNextPage}
        hasMore={hasNextPage}
        loader={isFetchingNextPage && <CircularProgress sx={{ display: "flex", justifyContent: "center", margin: "20px auto" }} />}
        scrollThreshold={0.8}
        endMessage={<p style={{ textAlign: "center" }}>You have seen it all!</p>}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          sx={{
            flex: "1 1 1",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "30px",
            rowGap: "32px",
          }}
          className="Grid-padding"
        >
          {data?.pages?.map((page) =>
            page.stockSetDesigns.map((design) => {
              const transformedProduct = design;
              return <StockSetProduct product={transformedProduct} key={design._id} allData={stockProductData} />;
            })
          )}
        </Grid>
      </InfiniteScroll>

      <GoToTop />

      {data?.pages?.length === 0 ||
        (!data?.pages.some((page) => page?.stockSetDesigns?.length > 0) && (
          <div
            style={{
              display: "flex",
              textAlign: "center",
              margin: "auto",
              padding: "auto",
              justifyContent: "center",
              alignItems: "center",
              height: "78vh",
            }}
          >
            <Background />
          </div>
        ))}
    </>
  );
};

export default StockSetsProducts;
